import { memo, useId } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-stability-ai-color-large.tsx
/**
* icon.24.logo.stability-ai.color.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0idXJsKCNhKSIgZD0iTTguMDkxIDE5LjM2NGMzLjQ4IDAgNS43NDItMS44MTYgNS43NDItNC41NDkgMC0yLjEyLTEuMzc2LTMuNDY2LTMuODM3LTQuMDI0bC0xLjU3OS0uNDY3Yy0xLjM4Ni0uMzA3LTIuMTk1LS42NzUtMi4wMDUtMS42MTYuMTYtLjc4My42MzMtMS4yMjUgMS43MzctMS4yMjUgMy41MDYgMCA0LjgwNSAxLjIyNSA0LjgwNSAxLjIyNVY1Ljc2M3MtMS4yNjUtMS4xMjYtNC44MDUtMS4xMjZjLTMuMzM5IDAtNS4xNSAxLjY5My01LjE1IDQuMzE0IDAgMi4xMiAxLjI1NiAzLjM1MiAzLjgwMSAzLjkzN2wuMjc0LjA2OHEuNTgxLjE3NyAxLjU2Ny40NjhjMS4zMDEuMzA3IDEuNjM2LjYzMyAxLjYzNiAxLjYwOSAwIC44OTItLjk0MSAxLjM5OS0yLjE4NSAxLjM5OUM0LjUwNiAxNi40MzIgMyAxNC42NDQgMyAxNC42NDR2My4yNjRzLjk0MiAxLjQ1NiA1LjA5MSAxLjQ1NiIvPjxwYXRoIGZpbGw9IiNlODAwMDAiIGQ9Ik0xOC44NTIgMTkuMTQxYzEuMjMxIDAgMi4xNDgtLjg3OCAyLjE0OC0yLjA2NiAwLTEuMjE1LS44OS0yLjA2Ny0yLjE0OC0yLjA2Ny0xLjIzMiAwLTIuMTIzLjg1Mi0yLjEyMyAyLjA2NyAwIDEuMjE0Ljg5MSAyLjA2NiAyLjEyMyAyLjA2NiIvPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0iYSIgeDE9IjguNDE3IiB4Mj0iOC40MTciIHkxPSI0LjYzNyIgeTI9IjE5LjM2NCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIHN0b3AtY29sb3I9IiM5RDM5RkYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNBMzgwRkYiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-12965
*/
const Icon24LogoStabilityAiColorLarge = memo(function Icon24LogoStabilityAiColorLarge(props) {
	const ida = useId();
	return /* @__PURE__ */ jsxs("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: [
			/* @__PURE__ */ jsx("path", {
				fill: `url(#${ida})`,
				d: "M8.091 19.364c3.48 0 5.742-1.816 5.742-4.549 0-2.12-1.376-3.466-3.837-4.024l-1.579-.467c-1.386-.307-2.195-.675-2.005-1.616.16-.783.633-1.225 1.737-1.225 3.506 0 4.805 1.225 4.805 1.225V5.763s-1.265-1.126-4.805-1.126c-3.339 0-5.15 1.693-5.15 4.314 0 2.12 1.256 3.352 3.801 3.937l.274.068q.581.177 1.567.468c1.301.307 1.636.633 1.636 1.609 0 .892-.941 1.399-2.185 1.399C4.506 16.432 3 14.644 3 14.644v3.264s.942 1.456 5.091 1.456"
			}),
			/* @__PURE__ */ jsx("path", {
				fill: "#e80000",
				d: "M18.852 19.141c1.231 0 2.148-.878 2.148-2.066 0-1.215-.89-2.067-2.148-2.067-1.232 0-2.123.852-2.123 2.067 0 1.214.891 2.066 2.123 2.066"
			}),
			/* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", {
				id: ida,
				x1: "8.417",
				x2: "8.417",
				y1: "4.637",
				y2: "19.364",
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ jsx("stop", { stopColor: "#9D39FF" }), /* @__PURE__ */ jsx("stop", {
					offset: "1",
					stopColor: "#A380FF"
				})]
			}) })
		]
	});
});
//#endregion
export { Icon24LogoStabilityAiColorLarge };

//# sourceMappingURL=icon-24-logo-stability-ai-color-large.js.map